import { createPlayStat } from "./create";
export var trackPlayStatApi = {
    createOne: createPlayStat,
};
